var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProposalDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3541 5C13.0876 5 13.4549 5.88678 12.9363 6.40542L8.58279 10.7589C8.26128 11.0804 7.74002 11.0804 7.41851 10.7589L3.06505 6.40542C2.54641 5.88678 2.91373 5 3.64719 5H12.3541Z",
    fill: "#8B93A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposalDropdown);
export default __webpack_public_path__ + "static/media/proposal-dropdown.3ec76b3668bbcf247a2e440b8f806a04.svg";
export { ForwardRef as ReactComponent };